/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  changePin(inboxId, pin) {
    return axios.post(`${this.url}/${inboxId}/change_pin`, {
      pin: pin,
    });
  }

  registerPin(inboxId, pin) {
    return axios.post(`${this.url}/${inboxId}/register_pin`, {
      pin: pin,
    });
  }

  register(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_app`);
  }
}

export default new Inboxes();
